import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_SOLICITUD_ANALISIS } from '../../../../config/tables'

function DatosSolicitudAnalisis () {
  return (
    <MuiTable id={TABLA_SOLICITUD_ANALISIS} />
  )
}

export default DatosSolicitudAnalisis
